//RETAILER
export const ALL_RETAILER_REQUEST = "ALL_RETAILER_REQUEST";
export const ALL_RETAILER_SUCCESS = "ALL_RETAILER_SUCCESS";
export const ALL_RETAILER_FAIL = "ALL_RETAILER_FAIL";

export const ALL_RETAILER_COMPANY_REQUEST = "ALL_RETAILER_COMPANY_REQUEST";
export const ALL_RETAILER_COMPANY_SUCCESS = "ALL_RETAILER_COMPANY_SUCCESS";
export const ALL_RETAILER_COMPANY_FAIL = "ALL_RETAILER_COMPANY_FAIL";